module.exports = __webpack_public_path__ + "img/ticket.600fa8d9.svg";